import React from "react";
import { defineMessages } from "react-intl";
import "../../bulk-operation/actions.js";
import "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import "../../bulk-operation/selectors.js";
import { BulkActionKey } from "../../bulk-operation/types.js";
import "rxjs";
import "rxjs/operators";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { withBulkStepSummaryContentDataGrid } from "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import { withBulkStepExecutionSummary } from "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../bulk-operation/components/DataGrid.js";
import "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import { DataGridBulkTransactionsClient } from "./DataGridWithBulkResults.js";
const localized = defineMessages({
  bulkTransactionType: {
    id: "bulkTransactionExecutionStep_type",
    defaultMessage: "transactions"
  }
});
const BulkTransactionP2PTransferExecutionStepGrid = withBulkStepExecutionSummary(
  withBulkStepSummaryContentDataGrid(DataGridBulkTransactionsClient, {
    columns: ["uid", "type", "amount", "errorRawLocalized"]
  })
);
function BulkTransactionP2PTransferExecutionStepModal({
  onNext,
  hasRetry,
  withFlexibleGrid,
  bulkOperationEntityType,
  strategy
}) {
  return /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferExecutionStepGrid,
    {
      onNext,
      hasRetry,
      affectedEntityName: localized.bulkTransactionType,
      bulkOperationEntityType,
      actionsData: [{ type: "operation", actionKey: BulkActionKey.P2PTransfer, strategy }],
      withFlexibleGrid
    }
  );
}
export {
  BulkTransactionP2PTransferExecutionStepModal
};
//# sourceMappingURL=BulkExecutionStepModal.js.map
